const handleStatusCard = ({
  filter,
  key = 'status',
  value,
  multiSelect = false,
}) => {
  const currentValues = filter.filters[key]

  if (multiSelect) {
    handleMultiSelect(filter, key, value, currentValues)
  } else {
    handleSingleSelect(filter, key, value, currentValues)
  }
}

const handleMultiSelect = (filter, key, value, currentValues) => {
  const currentArray = normalizeToArray(currentValues)

  if (currentArray.includes(value)) {
    removeValueFromFilter(filter, key, value, currentArray)
  } else {
    addValueToFilter(filter, key, value, currentArray)
  }
}

const handleSingleSelect = (filter, key, value, currentValues) => {
  const isCurrentlySelected =
    currentValues === value ||
    (Array.isArray(currentValues) && currentValues.includes(value))

  if (isCurrentlySelected) {
    removeFilterKey(filter, key)
  } else {
    filter.setFilters({ ...filter.filters, [key]: value })
  }
}

// Funções auxiliares
const normalizeToArray = (values) => {
  if (Array.isArray(values)) return values
  return values ? [values] : []
}

const removeValueFromFilter = (filter, key, value, currentArray) => {
  const updatedValues = currentArray.filter((item) => item !== value)

  if (updatedValues.length === 0) {
    removeFilterKey(filter, key)
  } else {
    filter.setFilters({ ...filter.filters, [key]: updatedValues })
  }
}

const addValueToFilter = (filter, key, value, currentArray) => {
  filter.setFilters({ ...filter.filters, [key]: [...currentArray, value] })
}

const removeFilterKey = (filter, key) => {
  const { [key]: removed, ...restFilters } = filter.filters
  filter.setFilters(restFilters)
}

export default handleStatusCard
